export var srcSetBuilder = function (_a) {
    var _b = _a.srcSet, srcSet = _b === void 0 ? [] : _b;
    var concattedSrcSet = [];
    var ImageSrcSet = '';
    srcSet.map(function (value) {
        var templated = value.templated;
        var dimensions = value.dimensions;
        var url = value.url;
        if (dimensions) {
            dimensions.map(function (value) {
                var w = value.width ? "w".concat(value.width) : '';
                if (templated === true) {
                    var h = value.height ? "h".concat(value.height) : '';
                    var resize = w + h;
                    url = url.replace('{resize}', resize);
                }
                ImageSrcSet = "".concat(url, " ").concat(value.width, "w");
                return ImageSrcSet;
            });
            return concattedSrcSet.push(ImageSrcSet);
        }
        else {
            return concattedSrcSet.push(url);
        }
    });
    return concattedSrcSet.length > 1 ? concattedSrcSet.join(', ') : concattedSrcSet[0];
};
export var sizesBuilder = function (sizesBuilder) {
    var concattedSizes = [];
    var defaultSize = sizesBuilder.find(function (a) { return !!a.default; });
    if (sizesBuilder) {
        sizesBuilder.map(function (props) {
            if (props.mq) {
                return concattedSizes.push("(min-width: ".concat(props.mq, ") ").concat(props.unit));
            }
            return concattedSizes.push(props.unit);
        });
    }
    if (defaultSize)
        concattedSizes.push("".concat(defaultSize.default));
    return concattedSizes.length > 1 ? concattedSizes.join(', ') : concattedSizes.toString();
};
